import styles from "./File.module.css";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import ArrowDownToBaseIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/ArrowDownToBaseIconPath";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import { useTranslation } from "@coworker/locales";

type FileProps = {
  name: string;
  size: string;
  onDownloadClick: () => void;
};

export function File({ name, size, onDownloadClick }: FileProps) {
  const { t } = useTranslation();

  return (
    <div className={styles["file"]}>
      <FixaButton
        iconOnly
        ssrIcon={ArrowDownToBaseIconPath}
        onClick={onDownloadClick}
        size="small"
        aria-label={`${t("downloadString")} ${name}`}
      />
      <div>
        <FixaText textStyle="Heading.XS" className={styles["fileName"]}>
          {name}
        </FixaText>
        <FixaText textStyle="Body.M">{size}</FixaText>
      </div>
    </div>
  );
}
